<!-- Created by Alex Poh. on 23/03/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<footer>
  <mat-divider></mat-divider>

  <div class="footer-container">
    <div class="logo-wrapper">
      <mat-icon fxLayoutAlign="start start" [inline]="true" svgIcon="app-logo"></mat-icon>
      <curr-static-pages></curr-static-pages>
    </div>
    <div class="copyright">{{ 'shared.footer.copyright' | translate }} © {{ date | date: 'y' }} - Curriculum LTD</div>
  </div>
</footer>
